export default {"src":"/_next/static/media/family_64.36c3a8ce.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};